// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"f619203a","488":"d3fbb76b"}[chunkId] + ".chunk.js";
};